import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { MapSearchService } from "../../../../shared/services/map-search/map-search.service";
import { BehaviorSubject } from "rxjs";
import { SessionStorageService } from "../../../../shared/services/storage/session-storage.service";
import { SearchTableService } from "../../../../shared/services/table-column-mapping/search-table.service";
import { HttpClient } from "@angular/common/http";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { Router } from "@angular/router";
import _ from "underscore";
import { SearchContainerHeight } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { StreetSearchOption } from "../enums/street-search-enum";
import GeometryUtils from "../../../../shared/utils/geometry-utils";
let StreetSearchService = class StreetSearchService extends MapSearchService {
    sessionStorageService;
    searchTableService;
    http;
    requestStatusService;
    router;
    streetUrl;
    streetSearchType;
    arcGisStreetOutColumnList;
    // @ts-ignore
    arcGisPropertyOutColumnList;
    streetList = new BehaviorSubject(null);
    streetListAsObservable = this.streetList.asObservable();
    streetSearchTableColumnMap = new BehaviorSubject(null);
    streetSearchTableColumnMapObservable = this.streetSearchTableColumnMap.asObservable();
    searchOptionsMap;
    selectedSearchOptionLookup;
    constructor(sessionStorageService, searchTableService, http, requestStatusService, router) {
        super(sessionStorageService, searchTableService);
        this.sessionStorageService = sessionStorageService;
        this.searchTableService = searchTableService;
        this.http = http;
        this.requestStatusService = requestStatusService;
        this.router = router;
        this.mapLocationAsObservable = this.mapLocation.asObservable();
    }
    setStreetList(foundStreetsArray) {
        this.streetList.next(foundStreetsArray);
    }
    clearURLList() {
        this.streetUrl = "";
    }
    setURL(searchType, url) {
        switch (searchType) {
            case StreetSearchOption.Street:
                this.streetUrl = url;
                break;
        }
    }
    setSearchOptionLookup(searchEnum) {
        this.searchOptionsMap = new Map();
        for (const [key, value] of Object.entries(searchEnum)) {
            // @ts-ignore
            this.searchOptionsMap.set(key, value);
        }
    }
    setSelectedSearchOption(searchOption) {
        this.selectedSearchOptionLookup = this.getSearchOptionLookup(searchOption);
        this.streetSearchType = StreetSearchOption.Street;
    }
    getSearchOptionLookup(selectedSearchOption) {
        const keys = [...this.searchOptionsMap.entries()]
            .filter(({ 1: v }) => v === selectedSearchOption)
            .map(([k]) => k);
        return keys.length > 0 ? keys[0].toString() : selectedSearchOption;
    }
    setTableColumnMap(tableColumnMap) {
        this.streetSearchTableColumnMap.next(tableColumnMap);
    }
    clearTableColumnMap() {
        this.streetSearchTableColumnMap.next(new Map());
    }
    getLayerUrl(searchType) {
        switch (searchType) {
            case StreetSearchOption.Street:
                return this.streetUrl;
            default:
                return this.streetUrl;
        }
    }
    // @ts-ignore
    transformFeature(feature, searchOption) {
        switch (searchOption ? searchOption : this.streetSearchType) {
            case StreetSearchOption.Street:
                return {
                    id: feature.attributes.OBJECTID ? feature.attributes.OBJECTID : (feature.attributes.objectid ? feature.attributes.objectid : null),
                    currentName: feature.attributes.Name ? feature.attributes.Name : (feature.attributes.name ? feature.attributes.name : null),
                    proposedName: feature.attributes.AlternativeName ? feature.attributes.AlternativeName : (feature.attributes.alternativename ? feature.attributes.alternativename : null),
                    locationDescription: feature.attributes.Place ? feature.attributes.Place : (feature.attributes.place ? feature.attributes.place : null),
                    featureType: feature.attributes.Type ? feature.attributes.Type : (feature.attributes.type ? feature.attributes.type : null),
                    ward: feature.attributes.Ward ? feature.attributes.Ward : (feature.attributes.ward ? feature.attributes.ward : null),
                    geometry: feature.geometry ? GeometryUtils.mapGeometryToDTO(feature.geometry) : (feature.attributes.Geometry ? GeometryUtils.mapGeometryToDTO(feature.geometry) : null)
                };
        }
    }
    getAttributeListForSearchType(searchOption) {
        switch (searchOption) {
            case StreetSearchOption.Street:
                return [..._.values(this.arcGisStreetOutColumnList)];
        }
    }
    // build links for map locator and create application request
    addMapLocatorLinks(foundStreetsArray) {
        foundStreetsArray.forEach(street => {
            street.link = this.setMapLink(street, SearchContainerHeight.StreetsLocationMap);
        });
        this.setStreetList(foundStreetsArray);
    }
    setMapLink(street, height) {
        return {
            text: SharedConstants.VIEW_ON_MAP_TEXT,
            address: "",
            clickAction: (link) => {
                this.changeMapLocation(String(street.id), height);
            }
        };
    }
    // setCreateApplicationLink(property) {
    //   return {
    //     text: SharedConstants.CREATE_APPLICATION_TEXT,
    //     address: "",
    //     clickAction: (link: ILink) => {
    //       this.startApplicationSelectedProperty(property);
    //     }
    //   };
    // }
    clearStreetsList() {
        this.streetList.next([]);
    }
    setCreateApplicationLink(street) {
        return undefined;
    }
    startApplicationSelectedProperty(property) {
        const url = this.getLayerUrl(StreetSearchOption.Street);
        // @ts-ignore
        this.doSearch(url, property.id.toString(), ArcGisPColumn.Id, true, StreetSearchOption.Street, true, true).then((result) => {
            if (result.length > 0) {
                this.router.navigate([this.getStartApplicationRoute()], { state: { propertyData: JSON.stringify(result[0]) } }).then();
            }
        });
    }
    getStartApplicationRoute() {
    }
    static ctorParameters = () => [
        { type: SessionStorageService },
        { type: SearchTableService },
        { type: HttpClient },
        { type: RequestStatusService },
        { type: Router }
    ];
};
StreetSearchService = __decorate([
    Injectable({
        providedIn: "root"
    })
], StreetSearchService);
export { StreetSearchService };
